import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

interface WalletModalProps {
  isOpen: boolean;
  onClose: () => void;
  studentId: string;
  onSuccess: () => void;
}

export default function WalletModal({ isOpen, onClose, studentId, onSuccess }: WalletModalProps) {
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!amount || !reason || !file) {
      toast.error("Por favor completa todos los campos y adjunta el ticket.");
      return;
    }

    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("amount", amount);
      fd.append("reason", reason);
      fd.append("proof", file);

      await api.addWalletCredit(studentId, fd);
      toast.success("Saldo agregado exitosamente");
      onSuccess();
      onClose();
    } catch (error: any) {
      toast.error(error.error || "Error al agregar saldo");
    }
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm animate-[fadeIn_0.2s_ease-out]">
      <div className="bg-[var(--color-bg-secondary)] rounded-2xl w-full max-w-md shadow-2xl overflow-hidden animate-[slideUp_0.3s_ease-out]">
        <div className="p-6 border-b border-[var(--color-border)] flex justify-between items-center bg-[var(--color-bg-card)]">
          <h2 className="text-xl font-bold text-[var(--color-text-primary)]">Agregar Saldo a Favor</h2>
          <button onClick={onClose} className="text-[var(--color-text-muted)] hover:text-[var(--color-text-primary)] cursor-pointer">
            <i className="ri-close-line text-2xl"></i>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-[var(--color-text-secondary)] mb-1">
              Monto a Abonar (USD)
            </label>
            <input
              type="number"
              step="0.01"
              min="0.01"
              required
              className="input-field w-full"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Ej: 50.00"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-[var(--color-text-secondary)] mb-1">
              Motivo / Registro
            </label>
            <input
              type="text"
              required
              className="input-field w-full"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Ej: Reembolso por cancelación de curso"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-[var(--color-text-secondary)] mb-1">
              Comprobante o Ticket (Obligatorio)
            </label>
            <input
              type="file"
              required
              accept="image/*,.pdf"
              className="w-full text-sm text-[var(--color-text-muted)] file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-[var(--color-accent)]/10 file:text-[var(--color-accent)] hover:file:bg-[var(--color-accent)]/20 cursor-pointer"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
            />
          </div>

          <div className="pt-4 flex justify-end gap-3">
            <button type="button" onClick={onClose} className="btn-secondary cursor-pointer">
              Cancelar
            </button>
            <button type="submit" disabled={loading} className="btn-primary cursor-pointer disabled:opacity-50">
              {loading ? "Procesando..." : "Agregar Saldo"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
